<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pv"></a>Contents</h1>
<p class="tocf"><a class="xref" href="#/hornefacing0006#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/hornefacing0007#ch01">1. Japan Rises/Negroes Cheer</a></p>
<p class="toc"><a class="xref" href="#/hornefacing0008#ch02">2. Harlem, Addis Ababa—and Tokyo</a></p>
<p class="toc"><a class="xref" href="#/hornefacing0009#ch03">3. Japan Establishes a Foothold in Black America</a></p>
<p class="toc"><a class="xref" href="#/hornefacing0010#ch04">4. White Supremacy Loses “Face”</a></p>
<p class="toc"><a class="xref" href="#/hornefacing0011#ch05">5. Pro-Tokyo Negroes Convicted and Imprisoned</a></p>
<p class="toc"><a class="xref" href="#/hornefacing0012#ch06">6. Japanese Americans Interned, U.S. Negroes Next?</a></p>
<p class="toc"><a class="xref" href="#/hornefacing0013#ch07">7. “Brown Americans” Fight “Brown Japanese” in the Pacific War?</a></p>
<p class="toc"><a class="xref" href="#/hornefacing0014#ch08">8. Aftermath</a></p>
<p class="tocbmf"><a class="xref" href="#/hornefacing0015#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/hornefacing0017#index">Index</a></p>
<p class="tocbm"><a class="xref" href="#/hornefacing0018#aubio">About the Author</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// hornefacing-0005.vue?79eb09df